export default __webpack_public_path__ + "static/media/royal-carribean-logo.b8c5f21a.png";